import SearchQueryWrapper from './SearchQueryWrapper';
export default SearchQueryWrapper;